module.exports = __webpack_public_path__ + "static/media/Layout-4-blocks.41ea91e5.svg";